module.exports = __webpack_public_path__ + "img/marco-smc.cc0b2cb4.jpg";